export default __webpack_public_path__ + "static/media/cancel.b4126829.svg";